export default "__VITE_ASSET__BguWkKw1__"